// If an item is sold and it doesn't match marketplace aid and share, or affiliate share it wont show in the frontend.
export const MARKETPLACE_AID =
  "a00c26536f73f0add51dddd5ef3220bb1842b2783e8ba1c4dd4a2da172b1727a";
export const MARKETPLACE_SHARE = 50; // 10000 is 100% ; 50 is 0.5%
export const ANVIL_SHARE = 50;

// if there is affiliate, that will be the share
export const AFFILIATE_SHARE = 100;

// This is the nft which curates the storefront
export const MARKETPLACE_STAKE_TOKEN_AUTHOR_AID = "aid";
